import React from 'react'
import { Link } from 'react-router-dom';
import Navbar from '../inc/Navbar';
import ScrollToTop from "react-scroll-to-top";
import GoverningBody from './GoverningBody';

function Governing() {
  return (
    <div>
            <Navbar/>
            <br />
            <br />

            <br />
            <br />


            <ScrollToTop smooth top="100" color="grey" />

            <div className='IslamicCharitableTrust'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Governing Body</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <GoverningBody/>
    </div>
  )
}

export default Governing